import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost' | 'link';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-sm font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold-500 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wider';
  const variants = {
    primary: 'bg-gold-500 text-black hover:bg-gold-400 shadow-lg shadow-gold-500/20',
    outline: 'border border-gold-500 text-gold-500 hover:bg-gold-500/10',
    ghost: 'text-gold-500 hover:bg-gold-500/10',
    link: 'text-gold-500 underline-offset-4 hover:underline p-0 h-auto'
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    md: 'h-11 px-6 text-sm',
    lg: 'h-14 px-8 text-base'
  };
  return <motion.button whileHover={{
    scale: disabled || isLoading ? 1 : 1.02
  }} whileTap={{
    scale: disabled || isLoading ? 1 : 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-180">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-181" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-182">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-183">{rightIcon}</span>}
    </motion.button>;
}